var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gacha-machine"},[_c('div',{staticClass:"tank-glow"}),_c('div',{ref:"canvasHost",staticClass:"canvas-host"}),_c('div',{staticClass:"chute"})])
}
var staticRenderFns = []

export { render, staticRenderFns }